import { Link } from 'react-router-dom';

import { Button } from '@motorway/mw-highway-code';

import { GuideAuthor } from '../../../@types/Wordpress';

import styles from './GuideAuthorCard.module.scss';

type GuideAuthorCardProps = GuideAuthor;

export const GuideAuthorCard: React.FC<GuideAuthorCardProps> = ({ id, image, jobTitle, name }) => (
  <div className={styles.wrapper}>
    {image && <div className={styles.image}>
      <picture>
        <img
          key={name}
          alt={`Photo of ${name}`}
          height="170"
          loading="lazy"
          src={image}
          width="227"
        />
      </picture>
    </div>}
    <div className={styles.info}>
      <h3 className={styles.name}>{name}</h3>
      <span className={styles.jobTitle}>{jobTitle}</span>
      <div>
        <Button as={Link} label="Read more" size='small' to={`/guides/authors/${id}`} variant='secondary' />
      </div>
    </div>
  </div>
);
